const moment = require('moment');

const DATE_STORE_LOCALE = 'en-GB';

const timePeriodRegex = /^([0-9]+)\s+(minutes|hours|days|weeks|months|years)/i;

const DATE_WITH_DAY_INCLUDED = 'dddd Do MMMM YYYY';
const DEFAULT_FORMAT = 'Do MMMM YYYY';

const formatDate = (timestamp, format = DEFAULT_FORMAT) => moment(timestamp).format(format);
const formatDateWithDayIncluded = timestamp => formatDate(timestamp, DATE_WITH_DAY_INCLUDED);

const getTimePeriod = stringTime => {
  const isPatternMatched = new RegExp(timePeriodRegex).test(stringTime);
  if (isPatternMatched) {
    const timeArray = stringTime.split(/\s+/);
    return {
      timeAmount: timeArray[0],
      timeUnit: timeArray[1]
    };
  }
  throw new Error(`${stringTime} did not match the regex`);
};

// Transform UTC date to locale date by timeZone name.
const toLocaleDate = (date, timeZone = 'UTC') => new Date(date).toLocaleString(DATE_STORE_LOCALE, { timeZone });

function dateRecently(datetime) {
  if (!datetime) {
    return '-';
  }
  return moment(datetime).fromNow();
}

function dateShort(datetime) {
  if (!datetime) {
    return '';
  }
  return moment(datetime).format('YY-MM-DD hh:mm');
}

function dateLong(datetime) {
  if (!datetime) {
    return '-';
  }
  return moment(datetime).format('MMMM Do YYYY, h:mm:ssa');
}

function getAbsoluteAndRelativeDateStrings(dateString = '') {
  if (!dateString) {
    return { absolute: '', relative: '' };
  }
  return { absolute: dateLong(dateString), relative: dateRecently(dateString) };
}

const compareDatesOp = {
  BEFORE: 'BEFORE',
  ONBEFORE: 'ONBEFORE',
  AFTER: 'AFTER',
  ONAFTER: 'ONAFTER'
};

const compareDates = (start, end, op) => {
  if (!op || !start || !end) {
    throw new Error('One or more arguments are missing');
  }

  const START_DATE_TIMESTAMP = new Date(`${start} GMT+00:00`).getTime();
  const END_DATE_TIMESTAMP = new Date(`${end} GMT+00:00`).getTime();

  return {
    [compareDatesOp.BEFORE]: START_DATE_TIMESTAMP < END_DATE_TIMESTAMP,
    [compareDatesOp.ONBEFORE]: START_DATE_TIMESTAMP <= END_DATE_TIMESTAMP,
    [compareDatesOp.AFTER]: START_DATE_TIMESTAMP > END_DATE_TIMESTAMP,
    [compareDatesOp.ONAFTER]: START_DATE_TIMESTAMP >= END_DATE_TIMESTAMP
  }[op];
};

module.exports = {
  formatDate,
  formatDateWithDayIncluded,
  getTimePeriod,
  toLocaleDate,
  dateRecently,
  dateShort,
  dateLong,
  getAbsoluteAndRelativeDateStrings,
  compareDatesOp,
  compareDates
};
